import { Nav } from "reactstrap";
import Layout from "../../custom/Layout";
import CustomNavItem from "../../custom/CustomNavItem";
import { TabContent } from "reactstrap";
import CustomTabPane from "../../custom/CustomTabPane";
import { useState } from "react";
import DataPull from "./DataPull";
import Drivers from "./Drivers";
import FlightDetail from "./FlightDetail";

export type TransfersAnalyticsTab = 'OVERVIEW' | 'DATA PULL' | 'DRIVERS' | 'FLIGHT DETAIL';

export default function TransfersAnalytics() {

    const [activeTab, setActiveTab] = useState<TransfersAnalyticsTab>('DATA PULL');

    const toggleTab = (tab: TransfersAnalyticsTab) => setActiveTab(tab);

    return (
        <Layout>
            <h1>Transfers Analytics</h1>
            <Nav tabs className={'separator-tabs'}>
                <CustomNavItem<TransfersAnalyticsTab>
                    tabName='OVERVIEW'
                    tabId='OVERVIEW'
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
                <CustomNavItem<TransfersAnalyticsTab>
                    tabName='DATA PULL'
                    tabId='DATA PULL'
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
                <CustomNavItem<TransfersAnalyticsTab>
                    tabName='DRIVERS'
                    tabId='DRIVERS'
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
                <CustomNavItem<TransfersAnalyticsTab>
                    tabName='FLIGHT DETAIL'
                    tabId='FLIGHT DETAIL'
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
            </Nav>
            <TabContent activeTab={activeTab} className={'mt-2'}>
                <CustomTabPane<TransfersAnalyticsTab> tabId={'DATA PULL'}>
                    <DataPull />
                </CustomTabPane>
                <CustomTabPane<TransfersAnalyticsTab> tabId={'DRIVERS'}>
                    <Drivers activeTabId={activeTab} />
                </CustomTabPane>
                <CustomTabPane<TransfersAnalyticsTab> tabId={'FLIGHT DETAIL'}>
                    <FlightDetail />
                </CustomTabPane>
            </TabContent>
        </Layout>
    );
}